import * as React from 'react';
import { StoreContext } from '../../../store/StoreProvider';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { MultiInput } from '../../MultiInput';
import FormControl from "@mui/material/FormControl";
import TextFieldDefault, { TextFieldProps } from "@mui/material/TextField";
import { InputAdornment } from '@material-ui/core';
import { getI18N } from '../../../i18n'
import AppConfig from '../../../constants/AppConfig';

// interface TurcasYCaicosProps { }
var ACTIVE_UPDATE = "";

type InputCustomProps = {};
type InputProps = InputCustomProps & TextFieldProps;
const TextField: any = React.forwardRef((props: InputProps, defRef: any) => {
  return <TextFieldDefault {...props} />;
});

const UserData = () => {
  const [store, dispatch] = React.useContext(StoreContext);
  const [showUpd, setUpd] = React.useState(false);
  // const [docType, setDocType] = React.useState("IDN");
  /*const [docTypeNac, setDocTypeNac] = React.useState(
    store?.inputSelectCountry?.ch_tipDoc || ""
  );*/
  const { battery } = store;

  const { Country } = store?.user;
  const currentLocale: string = Country || "PE";
  const i18n = getI18N({ currentLocale })

  let num = 0;
  for (let index = 0; index < battery?.DatosUsuario.length; index++) {
    if (!!battery?.DatosUsuario[index].Valor) num++;
  }

  const updateRequest = () => {
    ACTIVE_UPDATE = "USER";
    let btn: any = document?.getElementById("btn-submit");
    btn?.click();
  };

  let update = Number(battery?.Id) !== -1 ? true : false;
  if (!!battery?.TienePreTarjeta) {
    update = true;
  }
  let doc: any = battery?.DatosUsuario.find(({ IdDet }: any) => IdDet === AppConfig.userItemsType.DOCUMENT);

  let numDocumentValue = doc.Valor.split(" ");

  if (numDocumentValue.length > 1) {
    doc = {
      ...doc,
      Valor: numDocumentValue[1],
    };
  }

  doc = {
    ...doc,
    Tipo: "TXT",
  };

  let phone: any = battery?.DatosUsuario.find(({ IdDet }: any) => IdDet === AppConfig.userItemsType.PHONE);
  const numPhoneValue = phone.Valor.split(" ");

  if (!!phone.Valor) {
    if (numPhoneValue.length > 1) {

      phone = {
        ...phone,
        Valor: numPhoneValue[1],
      };
    }
  }

  let email: any = battery?.DatosUsuario.find(({ IdDet }: any) => IdDet === AppConfig.userItemsType.EMAIL);
  let name: any = battery?.DatosUsuario.find(({ IdDet }: any) => IdDet === AppConfig.userItemsType.NAMES);

  return (
    <details
      className={`details active ${num !== battery?.DatosUsuario.length ? "" : "success"}`}
    >
      <summary>
        <strong style={{ color: "#000" }}>
          {i18n.CLIENT_DATA}
        </strong>
        <div className="arrow-container d-flex">
          <span style={{ marginLeft: "10px" }}>{`(${num}/${battery?.DatosUsuario.length})`}</span>
          {/* <progress max={battery?.DatosUsuario.length} value={num}></progress> */}
          <ArrowDropDownIcon />
        </div>
      </summary>
      <div className="details-body">
        <div className="row" style={{ display: "flex" }}>
          <div className="col-sm-10" style={{ flex: 2 }}>
            <MultiInput
              data={doc}
              disabled={update}
              requred={doc?.FlgObligatorio}
              placeholder={doc.PlaceHolder}
              className="input-battery"
              parent="DatosUsuario"
              keyword={JSON.stringify(doc)}
              update={update}
              autoComplete="off"
              onChange={() => {
                if (!showUpd) setUpd(true);
              }}
              callback={updateRequest}
            />
          </div>
        </div>

        <FormControl fullWidth style={{ marginTop: 5 }}>
          <TextField
            fullWidth
            id="numPhone"
            disabled={update}
            required={phone?.FlgObligatorio}
            className={` ${"uppercase"} ${update ? "input-success" : ""}`}
            label={phone.PlaceHolder}
            data-parent={"DatosUsuario"}
            data-keyword={JSON.stringify(phone)}
            variant="outlined"
            value={((phone?.Valor) ? phone.Valor : undefined)}
            autoComplete="off"
            onChange={() => {
              if (!showUpd) setUpd(true);
            }}
            type={"text"}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">+1 649</InputAdornment>
              ),
              inputProps: {
                min: 7,
                max: 7,
                minLength: 7,
                maxLength: 7,
              },
            }}
            step={"any"}
            min={7}
            max={7}
          />
        </FormControl>

        <MultiInput
          data={email}
          disabled={update}
          requred={email?.FlgObligatorio}
          placeholder={email.PlaceHolder}
          className="input-battery"
          parent="DatosUsuario"
          keyword={JSON.stringify(email)}
          update={update}
          autoComplete="off"
          onChange={() => {
            if (!showUpd) setUpd(true);
          }}
          callback={updateRequest}
        />
        <MultiInput
          data={name}
          disabled={update}
          requred={name?.FlgObligatorio}
          placeholder={name.PlaceHolder}
          className="input-battery"
          parent="DatosUsuario"
          keyword={JSON.stringify(name)}
          update={update}
          autoComplete="off"
          onChange={() => {
            if (!showUpd) setUpd(true);
          }}
          callback={updateRequest}
        />
      </div>
    </details>
  );
};

export const TurcasYCaicos = (props: any) => {
  return (
    <>
      <UserData />
    </>
  );
};

